/* Customer reviews ticker + mobile slider */
(function () {
  'use strict';

  function initTicker(root) {
    if (!root) return;
    const track = root.querySelector('.reviews__track');
    if (!track) return;

    // Desktop ticker only
    const isMobile = window.matchMedia('(max-width: 749px)').matches;
    if (isMobile) {
      initMobileSlider(root, track);
      return;
    }

    // ----- Desktop vertical ticker -----
    if (!track.hasAttribute('data-cloned')) {
      const originalContent = track.innerHTML;
      track.innerHTML = originalContent + originalContent;
      track.setAttribute('data-cloned', 'true');
      track.offsetHeight;
    }

    const speed = Number(root.getAttribute('data-speed')) || 1000;
    const distancePx = track.scrollHeight / 2;
    const duration = distancePx / speed;
    track.style.setProperty('--desktop-duration', duration + 's');
  }

  function initMobileSlider(root, track) {
    const slides = track.children;
    if (!slides.length) return;

    let currentIndex = 0;

    // Create navigation buttons
    let controls = root.querySelector('.slider-controls');
    if (!controls) {
      controls = document.createElement('div');
      controls.className = 'slider-controls';
      controls.innerHTML = `
        <button class="prev">&#10094;</button>
        <button class="next">&#10095;</button>
      `;
      root.appendChild(controls);
    }

    const prevBtn = controls.querySelector('.prev');
    const nextBtn = controls.querySelector('.next');

    function updateSlide() {
      track.style.transform = `translateX(-${currentIndex * 100}%)`;
    }

    nextBtn.addEventListener('click', () => {
      currentIndex = (currentIndex + 1) % slides.length;
      updateSlide();
    });

    prevBtn.addEventListener('click', () => {
      currentIndex = (currentIndex - 1 + slides.length) % slides.length;
      updateSlide();
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-reviews-ticker]').forEach(initTicker);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
  document.addEventListener('shopify:section:select', function (e) {
    initAll(e.target);
  });
})();
